<template>
  <div class="user-center">
    <div class="header">
      <h2 class="title">主页概览</h2>
    </div>

    <!-- 数据卡片区域 -->
    <div class="data-cards">
      <div class="card-row">
        <!-- 第一行卡片 -->
        <div class="data-card blue">
          <div class="card-content">
            <div class="card-info">
              <div class="card-title">注册用户数量</div>
              <div class="card-value">{{totalUser}}</div>
            </div>
            <div class="card-icon">
              <i class="icon-people"></i>
            </div>
          </div>
        </div>

        <div class="data-card orange">
          <div class="card-content">
            <div class="card-info">
              <div class="card-title">申请订阅数量</div>
              <div class="card-value">{{ totalSub }}</div>
            </div>
            <div class="card-icon">
              <i class="icon-external"></i>
            </div>
          </div>
        </div>

        <div class="data-card green">
          <div class="card-content">
            <div class="card-info">
              <div class="card-title">产品数量</div>
              <div class="card-value">{{totalProduct}}</div>
            </div>
            <div class="card-icon">
              <i class="icon-employee"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getInfo } from "@/api";
export default {
  name: 'UserCenter',
  data() {
    return {
      totalUser:0,
      totalProduct:0,
      totalSub:0,
    }
  },
  created() {
    this.getUserList()
    this.getProductList()
    this.getSubList()
  },
  methods: {
    getUserList() {
      // 调用API接口获取数据
      getInfo({
        model: "user", // 模型名称
        condition: {}, // 查询条件
        page: 1, // 当前页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.totalUser = res.data.page_info.total_size; // 设置总记录数
        }
      });
    },
    getProductList() {
      // 调用API接口获取数据
      getInfo({
        model: "product", // 模型名称
        condition: {}, // 查询条件
        page: 1, // 当前页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.totalProduct = res.data.page_info.total_size; // 设置总记录数
        }
      });
    },
    getSubList() {
      // 调用API接口获取数据
      getInfo({
        model: "subscribe", // 模型名称
        condition: {}, // 查询条件
        page: 1, // 当前页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.totalSub = res.data.page_info.total_size; // 设置总记录数
        }
      });
    },
  },
}
</script>

<style scoped>
.user-center {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header {
  margin-bottom: 20px;
}

.title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.data-cards {
  margin-bottom: 20px;
}

.card-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.data-card {
  flex: 1;
  border-radius: 8px;
  padding: 20px;
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-info {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 16px;
  margin-bottom: 10px;
}

.card-value {
  font-size: 28px;
  font-weight: bold;
}

.card-icon {
  font-size: 24px;
  opacity: 0.8;
}

/* 卡片颜色 */
.blue {
  background-color: #4169E1;
}

.orange {
  background-color: #FFA500;
}

.green {
  background-color: #2E8B57;
}

.pink {
  background-color: #F08080;
}

.cyan {
  background-color: #20B2AA;
}

.blue-dark {
  background-color: #4682B4;
}

.chart-section {
  display: flex;
  gap: 20px;
}

.chart-container {
  flex: 1;
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.chart-header {
  margin-bottom: 15px;
}

.chart-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.chart {
  height: 300px;
}
</style>